<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:right-content="page.rightContent"
		/>

		<frequently-asked-questions v-for="faq in faqs" :key="faq.ID" :items="faq.faqitems" :header="faq.header" />

		<contentblocks
			v-if="page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:contentblocks-content="page.contentBlockContent"
		/>

		<pre-footer v-if="page.footerSection && page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].newsletterForm.title"
			:content="defaults[locale].newsletterForm.content"
			:email="defaults[locale].newsletterForm.email"
			:button="defaults[locale].newsletterForm.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: faqs } = await useWebsiteFetch('frequentlyAskedQuestions', {
	query: { language: locale.value },
	key: `${locale.value}/faqs`,
});
</script>
